import useWebSocket from 'react-use-websocket';
import { useDispatch, useSelector } from 'react-redux';
import { receiveWebSocket } from '../../actions/webSocketActions';
import { HOST_URL, protocol } from '../../constants/commonConstants';
import { useCallback } from 'react';
import { logout } from '../../actions/userActions';
import { getCookie } from '../../utils/cookieHelper';
import { decryptData } from '../../utils/crypto';
import { listMaintenanceInstances } from '../../actions/maintenanceInstanceAction';

const WebSocketComponent = () => {
	// console.log('HOST_URL', HOST_URL);
	// console.log('protocol', protocol);
	const extractPrefix = (url) => {
		// Regex to match everything up to the first '-'
		const regex = /^([^-]+)/;
		const match = url.match(regex);
	
		if (match && match[1]) {
			const segmentBeforeDash = match[1];
			// Check if the segment contains a `.`
			if (segmentBeforeDash.includes('.')) {
				// Extract everything before the `.`
				return segmentBeforeDash.split('.')[0];
			}
		}
		// If no match or no '.' in the segment, return 'public'
		return 'public';
	};
	// eslint-disable-next-line no-unused-vars
	const prefix = extractPrefix(HOST_URL);
	const wsProtocol = protocol === 'https:' ? 'wss://' : 'ws://'; 
	// console.log('prefix', prefix);
	const socketUrl =
		wsProtocol +
		HOST_URL +
		`/ws/alarm-notification-${decryptData(getCookie('tenantName'))}${Number(decryptData(getCookie('adminID')))}?subscribe-broadcast`;
	const dispatch = useDispatch();
	const loginState = useSelector((state) => state?.userLogin);
	const onMessageReceived = useCallback((message) => {
			// console.log('Received message:', message.data);
			// console.log('type------', typeof message.data);
			if (!loginState?.userInfo?.authorizationToken) return;
			if (message && message.data && message.data !== '--heartbeat--') {
				const dataFromServer = JSON.parse(message.data);
				if (
					dataFromServer.hasOwnProperty('type') &&
					dataFromServer['type'] === 'notification'
				) {
					const checkstatus =
						dataFromServer['notificationDescription'];
					if (
						!checkstatus || checkstatus.indexOf('online') > -1
					) return;

					if (dataFromServer['severityLevel'] === 1) {
						dispatch(receiveWebSocket(checkstatus));
					} else if (dataFromServer['severityLevel'] === 2) {
						dispatch(receiveWebSocket(checkstatus));
					} else if (dataFromServer['severityLevel'] === 3) {
						dispatch(receiveWebSocket(checkstatus));
					} else if (dataFromServer['severityLevel'] === 4) {
						dispatch(receiveWebSocket(checkstatus));
					} else if (dataFromServer['severityLevel'] === 5 && dataFromServer['notificationDescription'] === 'Logout') {
						dispatch(logout());
					} else if (dataFromServer['severityLevel'] === 5 && dataFromServer['notificationDescription'] === 'Banner Notification Updated') {
						dispatch(listMaintenanceInstances(5,0));
					}
				}
			}
		},[loginState]);
	// Initialize the useWebSocket hook
	useWebSocket(socketUrl, {
		// Optional configuration
		shouldReconnect: () => true,
		onMessage: onMessageReceived,
		onOpen: () => {
			console.log('WebSocket connection established');
		},
		onClose: () => {
			console.log('WebSocket connection closed');
		},
		onError: (error) => {
			console.error('WebSocket error:', error);
		},
	});
};

export default WebSocketComponent;
